module.exports = __webpack_public_path__ + "media/cuu/ppal_cuu_2-8a09512f.png";